// Prosper Card Web breakpoints (temporary names)
export const BREAKPOINT_DESKTOP = '101rem'; // 1616px
export const BREAKPOINT_TABLET = '80rem'; // 1280px
export const BREAKPOINT_LARGE_MOBILE = '48rem'; // 768px
export const BREAKPOINT_MOBILE = '30rem'; // 480px

// Old breakpoints
// export const LARGE_BREAKPOINT = '64rem'; // 1024px
// export const TABLET_BREAKPOINT = '53.125rem'; // 850px
// export const MOBILE_BREAKPOINT = '31.25rem'; // 500px
// export const SMALL_MOBILE_BREAKPOINT = '21.875rem'; // 350px

// New breakpoints
export const XLARGE_BREAKPOINT = '100rem'; // 1600px
export const LARGE_BREAKPOINT = '75rem'; // 1200px
export const TABLET_BREAKPOINT = '48rem'; // 768px
export const MOBILE_BREAKPOINT = '30rem'; // 480px
export const SMALL_MOBILE_BREAKPOINT = '21.875rem'; // 350px

export const colors = {
  BACKGROUND_GRAY: '#F7F7F7',
  BACKGROUND_RED_1: '#FDF4F4',
  BACKGROUND_RED: '#FDE6E6',
  BACKGROUND_TEAL_5: '#E5F2F3',
  BACKGROUND_TEAL_6: '#D1F1F1',
  BLACK: '#000000',
  BLUEISH_GRAY: '#64757D',
  BORDER_GRAY: '#F2F2F2',
  BORDER_GRAY_2: '#DCDEE0',
  BORDER_GRAY_3: '#838383',
  BORDER_GRAY_5: '#E6E6E6',
  BORDER_TEAL_2: '#009C9B',
  BORDER_TEAL_3: '#00B0AF',
  BORDER_TEAL_4: '#00a6a5',
  CHEVRON_GRAY: '#909090',
  DEFAULT_TEAL: '#00b0af',
  GRAY_61: '#616161',
  GRAY_81: '#818181',
  GRAY_95: '#959595',
  HOVER_GRAY: '#F8F8F8',
  ICON_GRAY: '#3C515C',
  LOADING_GRAY: '#E9E9E9',
  SHADOW_GRAY: '#727272',
  TEXT_BLACK: '#303030',
  TEXT_GRAY: '#4D4D4D',
  TEXT_GREEN_2: '#148235',
  TEXT_GREEN: '#007F86',
  TEXT_ORANGE: '#B85100',
  TEXT_RED: '#E30707',
  TEXT_TEAL_2: '#007F86',
  TEXT_TEAL_3: '#F0FBFB',
  TEXT_TEAL: '#009C9B',
  TITLE_GRAY: '#1E3743',
  TRANSPARENT: 'transparent',
  white: '#FFFFFF',
  WHITE: '#FFFFFF',

  // v1.5 colors
  APRICOT: '#FFE3CB',
  BLUE_WHALE: '#1E3743',
  SHEA: '#FAF5F0',
  PEACH: '#FCD3AF',
  ORANGE_PRESSED: '#F4EDE6',

  red: {
    red0: '#BB0202',
    red1: '#E30707',
    red2: '#F14B4B',
    red3: '#F17474',
    red4: '#F4A4A4',
    red5: '#F8D3D3',
    red6: '#FDE6E6',
    red7: '#FDF4F4',
  },

  orange: {
    orange0: '#B85100',
    orange1: '#DA6000',
    orange2: '#F06900',
    orange3: '#FE7800',
    orange4: '#FE993B',
    orange5: '#FFD3A6',
    orange6: '#FFE5C9',
    orange7: '#FFF6EC',
    orange8: '#FE800F',
    orange9: ' #FFF7F0'
  },

  yellow: {
    yellow0: '#A96200',
    yellow1: '#BB7607',
    yellow2: '#C5810C',
    yellow3: '#EDA30F',
    yellow4: '#F7CF08',
    yellow5: '#FBE473',
    yellow6: '#FFF7CB',
    yellow7: '#FFF9E8',
    yellow8: '#C58116',
  },

  green: {
    green0: '#148235',
    green1: '#319C07',
    green2: '#58AB6A',
    green3: '#7CBB74',
    green4: '#ABCE72',
    green5: '#D8E06E',
    green6: '#F3F4C9',
    green7: '#F3FFF0',
    green8: '#4EB748',
  },

  teal: {
    teal0: '#00666B',
    teal1: '#007F86',
    teal2: '#009C9B',
    teal3: '#00B0AF',
    teal4: '#3EC3C2',
    teal5: '#A4E2E2',
    teal6: '#D1F1F1',
    teal7: '#F0FBFB',
  },

  blue: {
    blue0: '#034E77',
    blue1: '#04679E',
    blue2: '#0A7CBC',
    blue3: '#36B2E1',
    blue4: '#55D3F5',
    blue5: '#9FE8FB',
    blue6: '#D6F5FD',
    blue7: '#F0FCFF',
  },

  pink: {
    pink0: '#AA0959',
    pink1: '#C70A69',
    pink2: '#E20C77',
    pink3: '#E83D92',
    pink4: '#EE6DAD',
    pink5: '#F6B6D6',
    pink6: '#FBDBEB',
    pink7: '#FEF4F9',
  },

  gray: {
    gray0: '#303030',
    gray1: '#4D4D4D',
    gray2: '#727272',
    gray3: '#909090',
    gray4: '#C6C6C6',
    gray5: '#E6E6E6',
    gray6: '#F2F2F2',
    gray7: '#F8F8F8',
    gray8: '#D8D8D8',
    gray9: '#C4C4C4',
    gray10: '#F7F7F7',
    gray11: '#9A9A9A',
    gray12: '#212121',
  },
};
